import React from 'react';
import { MusicIcon } from 'lucide-react';
const links = [{
  label: 'Termini e Condizioni',
  href: '#terms'
}, {
  label: 'Privacy',
  href: '#privacy'
}, {
  label: 'Contatti',
  href: '#contact'
}];
export function Footer() {
  return <footer className="w-full bg-cream px-5 py-14" data-id="element-93" data-mp="32pfgeet4hnzr">
      <div className="mx-auto max-w-3xl text-center" data-id="element-94" data-mp="36oxzd51dvozy">
        <p className="flex items-center justify-center gap-2 text-sm font-extrabold uppercase tracking-[0.24em] text-navy" data-id="element-95" data-mp="36ppjnjpj60ax">
          <MusicIcon className="h-4 w-4 text-orange" aria-hidden="true" data-id="element-96" data-mp="38quwwb59nq4" />
          Musica Pronta
        </p>
        <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-ink-soft" data-id="element-97" data-mp="3lem0o69kenno">
          Il curricolo musicale completo e pronto all'uso per la scuola primaria e secondaria
          italiana, per insegnanti e famiglie.
        </p>

        <nav aria-label="Footer" className="mt-7" data-id="element-98" data-mp="29ydxq3q81abh">
          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm" data-id="element-99" data-mp="2ey9wnok2abk6">
            {links.map(link => <li key={link.label} data-id="element-100" data-mp="3lalhzkmm4fwl">
                <a href={link.href} className="text-ink-soft underline-offset-4 transition-colors duration-150 ease-out hover:text-orange hover:underline" data-id="element-101" data-mp="3lbmt1p3mp2eb">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <p className="mt-8 border-t border-navy/10 pt-6 text-xs text-ink-soft" data-id="element-102" data-mp="830jhjn6y710">
          © 2026 Musica Pronta — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}